import React from "react"
import { Wrapper } from "./styles"

export function Youtube({ link }) {
	return (
		<Wrapper>
			<iframe
				width="100%"
				src={link}
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</Wrapper>
	)
}
